import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/remote-config'

const firebaseConfig = {
  apiKey: "AIzaSyBg5nGnkDv2CJeVnrtaO_uwWUQfrhYbIjs",
  authDomain: "athlinks-159018.firebaseapp.com",
  databaseURL: "https://athlinks-159018.firebaseio.com",
  projectId: "athlinks-159018",
  storageBucket: "athlinks-159018.appspot.com",
  messagingSenderId: "845497580406",
  appId: "1:845497580406:web:3b766daad83e3c09129857",
  measurementId: "G-2QPY4VKFP3"
}
const app = firebase.initializeApp(firebaseConfig)
app.analytics()
export default app